<template>
  <div class="wrap-box">
    <div
      class="top-box"
    >
      <div class="content-box">
        <!-- 车辆信息 -->
        <div class="car-info-box card-box card-padding">
          <div class="car-info-item">
            <span>订单号：</span>
            <span
              class="car-no order-no"
              :class="{
                'color-red': taskDetail.vipCompany === '1',
                'order-svip': isZvVipAndVipCompany,
              }"
            >{{ taskDetail.orderNo || "-" }}</span>
            <div
              class="zv-vip-icon"
              v-if="isShowZvVip"
            >至尊VIP</div>
            <div
              class="zv-vip-icon"
              v-if="isShowBcCustomer"
            >黑钻客户</div>
            <img
              v-if="taskDetail.vipCompany === '1'"
              src="@/assets/img/orderGeneral/vipCompany.png"
              class="vip-icon"
            >
            <div>
              <div
                class="copy"
                @click="copy"
              >复制</div>
            </div>
          </div>
          <div
            class="car-info-item"
            v-if="isShowTrailer"
          >
            <span :class="{ car_red: isNoCar }">车牌号码：</span>
            <span
              class="car-no"
              v-if="taskDetail.carNo && !isEditCar"
            >{{
              taskDetail.carNo || ""
            }}</span>
            <span
              class="car-no"
              v-if="carNo && !isEditCar"
            >{{
              carNo || ""
            }}</span>
            <van-icon
              class="edit"
              v-if="!taskDetail.carNo && !isEditCar"
              @click="editCar"
              name="edit"
            />
            <van-field
              v-model="carNo"
              v-if="isEditCar"
              @blur="blurCar"
              :maxlength="10"
              class="carNo"
              placeholder="请输入车牌号码"
            />
          </div>
          <div
            class="car-info-item"
            v-if="!isShowTrailer"
          >
            <span>车牌号码：</span>
            <span class="car-no">{{ taskDetail.carNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>车架号码：</span>
            <span>{{ taskDetail.vinNo || "-" }}</span>
          </div>
          <div
            class="car-info-item"
            v-if="!isShowTrailer"
          >
            <span>优惠信息：</span>
            <span>{{ rightRemark }}</span>
          </div>
        </div>
        <!-- 服务项目 -->
        <div
          class="card-box card-padding"
          style="padding-bottom: 6px"
          v-if="isShowTrailer"
        >
          <div class="card-title-sub">确认此次事故救援需要的服务项目</div>
          <div>
            <van-collapse
              v-model="activeNames"
              @change="accidentChange"
              :border="false"
            >
              <van-collapse-item
                v-for="(item, index) in queryAccidentList"
                class="collapse"
                :key="index"
                :value="item.active ? '收起' : '选择'"
                value-class="accidentValue"
                :name="item.code"
                :border="false"
              >
                <template #title>
                  <span>{{ item.desc }}</span>
                  <span
                    :class="{ isActive: item.active }"
                  >（{{ item.active ? item.info : item.number }}）</span>
                </template>
                <div class="select-box">
                  <div
                    v-for="(items, indexs) in item.list"
                    :key="indexs"
                    class="select-item"
                    @click="select(item, items)"
                    :class="{ active: items.checked }"
                  >
                    {{ items.productSkuName
                    }}{{
                      item.code === "A" && items.limitKm
                        ? `(${items.limitKm}KM)`
                        : ""
                    }}
                  </div>
                </div>
                <div
                  v-if="item.code == 'D' && isFZL"
                  class="select-box"
                >
                  <div style="width: 100%; margin-bottom: 10px">
                    辅助轮(含平移轮)/个
                  </div>
                  <div
                    v-for="(itemsub, indexsub) in queryValueList"
                    :key="indexsub"
                    class="select-item"
                    :class="{ active: itemsub.checked }"
                    @click="selectValue(itemsub)"
                  >
                    {{ itemsub.value }}
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
        <!-- 类型 -->
        <div
          class="card-box card-padding"
          v-if="!isShowTrailer"
        >
          <div class="card-title card-title-flex">
            <span>类型</span>
            <span class="card-title-info">
              {{ taskDetail.productCategoryName }}
            </span>
          </div>
        </div>
        <!-- 当前环境 -->
        <div
          class="card-box card-padding"
          v-if="!isShowTrailer"
        >
          <div class="card-title">当前环境</div>
          <selectBox
            :data-list="currentEnvList"
            :value.sync="dataForm.rescueCurrentEnv"
            @update:value="selectCurrentEnv"
          />
        </div>
        <!-- 是否需要拖车 -->
        <div
          class="card-box card-padding"
          v-if="isTrailer || isBasementTrailer"
        >
          <template v-if="isDifficultyRelief">
            <!-- v1.8.4.2隐藏是否拖车控件 -->
            <div
              class="card-title card-title-flex"
              v-if="false"
            >
              <span>是否需要拖车</span>
              <van-checkbox
                v-model="dataForm.useTraceCar"
                shape="square"
                @change="useTraceCarChange"
              />
            </div>
            <template v-if="dataForm.useTraceCar">
              <van-divider style="margin: 16px -16px" />
              <div class="card-title">拖车(吨)</div>
              <selectBox
                :data-list="trailerTonnageList"
                :value.sync="dataForm.useTraceCarTon"
              />
              <div class="placeholder-box" />
            </template>
          </template>
          <template v-if="isTrailer || isBasementTrailer">
            <template v-if="showTrainingWheels">
              <div class="card-title">辅助轮数量(个）</div>
              <selectBox
                :data-list="trainingWheelsList"
                :value.sync="dataForm.trainingWheels"
                @update:value="selectTrainingWheels"
              />
            </template>
            <template v-if="showShopDrawing">
              <div class="placeholder-box" />
              <van-checkbox
                v-model="dataForm.useShopDrawing"
                shape="square"
                @change="selectShopDrawing"
              >
                是否使用地库牵引
              </van-checkbox>
            </template>
          </template>
        </div>
        <div
          class="card-box card-padding"
          v-if="isDifficultyRelief && showVasTrailer"
        >
          <van-checkbox
            v-model="dataForm.needVasTrailer"
            shape="square"
          >
            是否需要拖车
          </van-checkbox>
        </div>
        <div
          class="card-box card-padding"
          v-if="isDifficultyRelief && showVasCrane"
        >
          <van-checkbox
            v-model="dataForm.needVasCrane"
            shape="square"
          >
            是否需要吊车
          </van-checkbox>
        </div>
        <!-- 吊车、叉车、挖掘机 -->
        <template v-if="isDifficultyRelief">
          <div class="card-box card-padding">
            <ActionSheetBox
              title="吊车"
              :data-list="craneDataList"
              :value.sync="dataForm.rescueCrane"
            />
            <van-divider />
            <ActionSheetBox
              title="叉车"
              :data-list="forkliftDataList"
              :value.sync="dataForm.rescueForklift"
            />
            <van-divider />
            <ActionSheetBox
              title="挖掘机"
              :data-list="excavatorDataList"
              :value.sync="dataForm.rescueGrabMachine"
            />
          </div>
        </template>
        <!-- 现场情况 -->
        <div class="card-box card-padding">
          <div
            class="card-title card-title-flex"
            v-if="!isShowTrailer"
          >
            <span>现场情况</span>
            <van-checkbox
              shape="square"
              @click="toPage('GeneralOrderEvacuation')"
            >
              放空
            </van-checkbox>
          </div>
          <van-divider
            style="margin: 16px -16px"
            v-if="!isShowTrailer"
          />
          <template v-if="isHAIC && isTrailer">
            <div
              class="card-title card-title-flex"
              ref="blackScreenRef"
            >
              <span>仪表盘无故障码/黑屏/无法确认故障码</span>
              <van-checkbox
                shape="square"
                v-model="dataForm.isBlackScreens"
                @change="handleBlackScreensChange"
              >
                是
              </van-checkbox>
            </div>
            <van-divider
              style="margin: 8px -16px"
            />
            <div
              class="card-title card-title-flex"
            >
              <span>仪表盘正常显示故障码</span>
              <van-checkbox
                shape="square"
                v-model="dataForm.noBlackScreens"
                @change="handleNoBlackScreensChange"
              >
                是
              </van-checkbox>
            </div>
            <van-divider
              style="margin: 16px -16px"
            />
          </template>
          <Certificate
            v-if="taskDetail.taskNo"
            use-incoming-is-black-screens
            :show-black-screens-tips="dataForm.isBlackScreens"
            :photo-params="photoParams"
            @uploadCompleted="checkPictureNum"
          />
        </div>
        <WorkOrders
          v-if="isDifficultyRelief || isRoadside"
          ref="workOrdersRef"
          use-incoming-is-black-screens
          :is-black-screens="dataForm.isBlackScreens"
          :order-no="taskDetail.orderNo"
          :task-no="taskDetail.taskNo"
          @clickHandler="setCurrentScrollTop"
        />
        <!-- 救援结果 -->
        <div
          class="card-box card-padding"
          v-if="!needToTrailer && !isShowTrailer"
        >
          <div class="card-title card-title-flex">
            <span>救援结果</span>
            <van-checkbox
              v-model="dataForm.rescueFailed"
              shape="square"
            >
              救援失败
            </van-checkbox>
          </div>
          <van-divider style="margin: 16px -16px" />
          <ReasonSelectBox
            v-if="dataForm.rescueFailed"
            ref="reasonSelectBox"
            title="请选择对应的救援失败原因"
            :data-list="reasonDataList"
            :value.sync="dataForm.rescueFailedReason"
            :maxlength="400"
          />
          <van-field
            v-else
            class="textarea-box"
            v-model="dataForm.rescueOpinion"
            rows="3"
            autosize
            type="textarea"
            placeholder="请输入您的意见（原因）"
            maxlength="400"
          />
        </div>

        <!-- 确认弹窗 -->
        <ConfirmDialog ref="confirmDialog" />
        <!-- 订单费用录入 -->
        <OrderCostEntryBox ref="orderCostEntryBox" />
      </div>
    </div>
    <div class="bottom-box">
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        {{ needToTrailer ? "点击开始拖车" : "点击执行完成" }}
      </ClickButton>
    </div>
    <!-- 去到底部 -->
    <ShowMore
      ref="showMoreRef"
      wrap-box="top-box"
    />
    <!-- 服务完成 -->
    <ServiceEndDialog
      ref="serviceEndRef"
      :arrive-mileage="taskDetail.arriveMileage"
      @confirm="serviceEndConfirm"
    />
    <AddValueProductDialog ref="addValueProductDialogRef" />

  </div>
</template>

<script>
import {
  paicProductCode,
  TASK_STATUS_CODE,
  generalProductCode
} from '@/common/constant';
import ClickButton from '@/components/clickButton.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
import SelectBox from '../components/selectBox.vue';
import ActionSheetBox from '../components/actionSheetBox.vue';
import ReasonSelectBox from '../components/reasonSelectBox.vue';
import OrderCostEntryBox from '../components/orderCostEntryBox.vue';
import Certificate from '../components/certificate.vue';
import WorkOrders from '../components/workOrders.vue';
import ShowMore from '../components/showMore.vue';
import ServiceEndDialog from '../../paicOrder/components/serviceEndDialog.vue';
import {
  getTaskDetail,
  getRightRemark,
  getExtraProductList,
  checkPictureNum,
  saveInfo,
  savePictureTemplate,
  beginWork,
  executeSuccess,
  rescueResult,
  queryAccidentVasDict,
  getRescueReport,
  appealDistance,
  getMediaTemplate
} from '@/common/apiPaic.js';
import { queryDictByCodes } from '@/common/api.js';
import { handleClipboard } from '@/common/clipboard';
import { REGEX_LPN } from '@/common/regex.js';
import { Toast } from 'vant';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import AddValueProductDialog from '@/views/generalOrder/roadOrDistressRescue/addValueProductDialog.vue';
const initDataForm = () => {
  return {
    rescueCurrentEnv: 'COMMON_GROUND',
    useTraceCar: false,
    useTraceCarTon: '5',
    trainingWheels: '',
    useShopDrawing: false,
    rescueCrane: '无',
    rescueForklift: '无',
    rescueGrabMachine: '无',
    rescueFailed: false,
    rescueOpinion: '',
    rescueFailedReason: '',
    needVasTrailer: false,
    needVasCrane: false,
    isBlackScreens: false,
    noBlackScreens: false
  };
};

export default {
  name: 'GeneralOrderTaskExecution',
  mixins: [getCurrentPositionMixin],
  components: {
    ClickButton,
    ConfirmDialog,
    SelectBox,
    ActionSheetBox,
    ReasonSelectBox,
    OrderCostEntryBox,
    ServiceEndDialog,
    Certificate,
    WorkOrders,
    ShowMore,
    AddValueProductDialog
  },
  data() {
    return {
      dataForm: initDataForm(),
      taskDetail: {},
      currentEnvList: [],
      trailerTonnageList: [],
      trainingWheelsList: [
        {
          key: '1',
          value: '1'
        },
        {
          key: '2',
          value: '2'
        },
        {
          key: '3',
          value: '3'
        },
        {
          key: '4',
          value: '4'
        },
        {
          key: '',
          value: '无'
        }
      ],
      craneDataList: [],
      forkliftDataList: [],
      excavatorDataList: [
        {
          key: '有',
          value: '有'
        },
        {
          key: '无',
          value: '无'
        }
      ],
      reasonDataList: [],
      orderNo: '',
      taskNo: '',
      imageInfo: {},
      extraProductList: [],
      needFinalConfirm: false,
      imageCompleted: false,
      rightRemark: '',
      activeNames: [],
      queryAccidentList: [],
      isQueryAccident: false,
      isEditCar: false,
      carNo: '',
      queryValueList: [
        {
          value: '1',
          checked: false
        },
        {
          value: '2',
          checked: false
        },
        {
          value: '3',
          checked: false
        },
        {
          value: '4',
          checked: false
        }
      ],
      isShowTrailer: true,
      isNoCar: false,
      isFZL: false,
      // 事故救援类型数组
      accidentRescueTypeList: ['FL90000002', 'FL90000003', 'FL90000004'],
      reportData: {},
      copyText: '',
      originalTrainingWheels: '', //  订单原始的辅助轮
      originalUseShopDrawing: false, // 订单原始的地库牵引
      cricTips: '添加增值产品请报备中保操作',
      ccqcTips: '如需地库，请反馈中保客服，系统单独下地库单',
      preRescueCurrentEnv: '',
      preTrainingWheels: '',
      isAddProduct: false
    };
  },
  computed: {
    // 拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 地库拖车
    isBasementTrailer() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000003].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 困境救援
    isDifficultyRelief() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FLA0000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    // 道路救援
    isRoadside() {
      return (
        this.taskDetail &&
        [paicProductCode.categoryCode_FL10000001].includes(
          this.taskDetail.categoryParentCode
        )
      );
    },
    // 困境救援 是否有增值产品拖车 浙商对接时添加
    showVasTrailer() {
      const descArr = this.extraProductList.map((item) => item.desc);
      return descArr.includes('00009');
    },
    // 困境救援 是否有增值产品吊车 浙商对接时添加
    showVasCrane() {
      const descArr = this.extraProductList.map((item) => item.desc);
      return descArr.includes('00005');
    },
    // 是否有辅助轮
    showTrainingWheels() {
      const descArr = this.extraProductList.map((item) => item.desc);
      return descArr.includes('00001');
    },
    // 是否有地库牵引
    showShopDrawing() {
      const descArr = this.extraProductList.map((item) => item.desc);
      return (
        descArr.includes('00002') &&
        this.dataForm.rescueCurrentEnv === 'BASEMENT'
      );
    },
    // 需要去拖车
    needToTrailer() {
      return this.isTrailer || this.isBasementTrailer || this.isQueryAccident;
    },
    // 是否完善
    isPerfection() {
      return (
        (!this.dataForm.rescueFailed &&
        this.reportData &&
        this.reportData.customerSign &&
        this.reportData.operatorSign &&
        this.reportData.carStatus) ||
        (this.dataForm.rescueFailed &&
        this.reportData &&
        this.reportData.operatorSign &&
        this.reportData.carStatus)
      );
    },
    // 是否已到达
    isArriveStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.arrive;
    },
    // 送水，送油，送防冻液，更换轮胎，搭电，取送钥匙，轮胎打气、困境救援
    isShowService() {
      return [
        generalProductCode.categoryCode_FL10000008,
        generalProductCode.categoryCode_FL10000009,
        generalProductCode.categoryCode_FL10000010,
        generalProductCode.categoryCode_FL10000005,
        generalProductCode.categoryCode_FL10000006,
        generalProductCode.categoryCode_FL10000007,
        generalProductCode.categoryCode_FL10000004,
        generalProductCode.categoryCode_FL10000004,
        generalProductCode.categoryCode_FLA0000001,
        generalProductCode.categoryCode_FLA0000002
      ].includes(this.taskDetail.categoryCode);
    },
    photoParams() {
      const photoParams = this.getPhotoParams();
      return {
        ...photoParams,
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        hasUnderGround: this.dataForm.useShopDrawing
      };
    },
    // 是否显示至尊vip
    isShowZvVip() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_ZV')
      );
    },
    // 是否显示黑钻客户
    isShowBcCustomer() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_BC')
      );
    },
    // 至尊vip和重点保司
    isZvVipAndVipCompany() {
      return (
        this.taskDetail.vipCompany === '1' &&
        (this.isShowZvVip || this.isShowBcCustomer)
      );
    },
    // 是否富德
    isCRIC() {
      return this.taskDetail.channelCompanyNo === 'CRIC';
    },
    // 是否长城
    isCCQC() {
      return this.taskDetail.channelCompanyNo === 'CCQC';
    },
    // 是否华安
    isHAIC() {
      return this.taskDetail.channelCompanyNo === 'HAIC';
    }
  },
  watch: {
    // 'dataForm.rescueCurrentEnv'(val) {
    //   if (!this.isCRIC && val === 'BASEMENT') {
    //     this.dataForm.useShopDrawing = true;
    //   } else {
    //     this.dataForm.useShopDrawing = false;
    //   }
    // }
    'dataForm.rescueCurrentEnv'(val) {
      console.log('___val----', val);
      if ((this.isCRIC || this.isCCQC) && val === 'BASEMENT') {
        this.dataForm.useShopDrawing = false;
      } else {
        if (val === 'BASEMENT') {
          this.dataForm.useShopDrawing = true;
        } else {
          this.dataForm.useShopDrawing = false;
        }
      }
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
  },
  mounted() {
    this.queryDictByCodes();
  },
  activated() {
    this.checkPictureNum();
    this.getRescueReport();
  },
  methods: {
    selectCurrentEnv() {
      if (this.isCRIC && this.dataForm.rescueCurrentEnv === 'BASEMENT') {
        this.$dialog
          .alert({
            message: this.cricTips
          }).then(() => {
            this.dataForm.rescueCurrentEnv = this.preRescueCurrentEnv || 'COMMON_GROUND';
            this.preRescueCurrentEnv = this.dataForm.rescueCurrentEnv;
            this.checkPictureNum();
          });
      } else if (this.isCCQC && this.dataForm.rescueCurrentEnv === 'BASEMENT') {
        this.$dialog
          .alert({
            message: this.ccqcTips
          }).then(() => {
            this.dataForm.rescueCurrentEnv = this.preRescueCurrentEnv || 'COMMON_GROUND';
            this.preRescueCurrentEnv = this.dataForm.rescueCurrentEnv;
            this.checkPictureNum();
          });
      } else {
        this.preRescueCurrentEnv = this.dataForm.rescueCurrentEnv;
        this.checkPictureNum();
      }
    },
    selectTrainingWheels() {
      if (this.isCRIC && this.dataForm.trainingWheels > 0) {
        this.$dialog
          .alert({
            message: this.cricTips
          }).then(() => {
            this.dataForm.trainingWheels = this.preTrainingWheels;
            this.preTrainingWheels = this.dataForm.trainingWheels;
            this.checkPictureNum();
          });
      } else {
        this.preTrainingWheels = this.dataForm.trainingWheels;
        this.checkPictureNum();
      }
    },
    selectShopDrawing() {
      if (this.isCRIC && this.dataForm.useShopDrawing) {
        this.$dialog
          .alert({
            message: this.cricTips
          }).then(() => {
            this.dataForm.useShopDrawing = false;
            this.checkPictureNum();
          });
      } else if (this.isCCQC && this.dataForm.useShopDrawing) {
        this.$dialog
          .alert({
            message: this.ccqcTips
          }).then(() => {
            this.dataForm.useShopDrawing = false;
            this.checkPictureNum();
          });
      } else {
        this.checkPictureNum();
      }
    },
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.reportData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goWorkOrders() {
      const list = [];
      if (this.showShopDrawing) {
        list.push('地库牵引(1)');
      }
      if (this.dataForm.trainingWheels) {
        list.push(`辅助轮(${this.dataForm.trainingWheels})`); // 辅助轮
      }
      this.$router.push({
        name: 'GeneralOrderWorkOrders',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          extraProduct: list.length > 0 ? list.join(',') : '',
          isH5: true
        }
      });
    },
    accidentChange(e) {
      this.queryAccidentList &&
        this.queryAccidentList.forEach((item) => {
          this.$set(item, 'active', false);
          e &&
            e.forEach((items) => {
              if (items === item.code) {
                this.$set(item, 'active', true);
              }
            });
        });
    },
    copy(e) {
      handleClipboard(this.copyText, e);
    },
    async queryAccidentVasDict() {
      try {
        const data = await queryAccidentVasDict({
          orderNo: this.orderNo
        });
        this.queryAccidentList = data;
        this.queryAccidentList &&
          this.queryAccidentList.forEach((item) => {
            if (item.code === 'D') {
              this.$set(item, 'info', '可多选');
              this.isFZL =
                item.list &&
                item.list.some((items) => {
                  return items.parameter === 'D01';
                }); // 辅助轮
            } else {
              this.$set(item, 'info', '单选');
            }
            this.$set(item, 'number', 0);
            this.$set(item, 'active', false);
            item.list &&
              item.list.forEach((items) => {
                this.$set(items, 'checked', false);
                this.$set(items, 'code', item.code);
              });
          });
      } catch (error) {
        console.log(error);
      }
    },
    select(data, datas) {
      if (data.code === 'D') {
        // 困境多选
        datas.checked = !datas.checked;
        data.number = 0;
        data.list &&
          data.list.forEach((item) => {
            if (item.checked) {
              data.number = data.number + 1;
            }
            if (datas.parameter === 'D01' && datas.checked) {
              this.queryValueList[0].checked = true;
            } else if (datas.parameter === 'D01' && !datas.checked) {
              this.queryValueList.forEach((items) => {
                items.checked = false;
              });
            }
          });
      } else {
        data.list &&
          data.list.forEach((item) => {
            if (item.productSkuCode === datas.productSkuCode) {
              datas.checked = !datas.checked;
              if (datas.checked) {
                this.$set(data, 'number', 1);
              } else {
                this.$set(data, 'number', 0);
              }
            } else {
              this.$set(item, 'checked', false);
            }
          });
      }
      this.queryAccidentList &&
        this.queryAccidentList.forEach((item) => {
          if (item.code === 'A') {
            this.isQueryAccident = item.list.some((items) => {
              return items.checked;
            });
          }
        });
      this.checkPictureNum();
    },
    selectValue(data) {
      const queryObj = this.queryAccidentList.filter((item) => {
        return item.code === 'D';
      });
      this.queryValueList &&
        this.queryValueList.forEach((item) => {
          if (data.value === item.value) {
            data.checked = !data.checked;
            if (data.checked) {
              queryObj[0].list.forEach((items) => {
                if (items.parameter === 'D01') {
                  this.$set(items, 'checked', true);
                }
              });
            } else {
              queryObj[0].list.forEach((items) => {
                if (items.parameter === 'D01') {
                  this.$set(items, 'checked', false);
                }
              });
            }
          } else {
            this.$set(item, 'checked', false);
          }
        });
      queryObj &&
        queryObj.forEach((item) => {
          item.number = 0;
          item.list &&
            item.list.forEach((items) => {
              if (items.checked) {
                item.number = item.number + 1;
              }
            });
        });
      this.checkPictureNum();
    },
    editCar() {
      this.isEditCar = true;
      this.isNoCar = false;
    },
    blurCar() {
      this.isEditCar = false;
    },
    /**
     * 处理仪表盘无故障码/黑屏/无法确认故障码选项的变化
     * @param {boolean} value - 当前选项的选中状态
     */
    handleBlackScreensChange(value) {
      if (value) {
        this.dataForm.noBlackScreens = false;
      }
    },
    /**
     * 处理仪表盘正常显示故障码选项的变化
     * @param {boolean} value - 当前选项的选中状态
     */
    handleNoBlackScreensChange(value) {
      if (value) {
        this.dataForm.isBlackScreens = false;
      }
    },
    useTraceCarChange(val) {
      // 判断环境来设置救援失败选项
      if (val) {
        this.dataForm.rescueFailed = false;
        this.dataForm.rescueOpinion = '';
        this.dataForm.rescueFailedReason = '';
      }
      // 判断环境来设置地库牵引选项
      if (val && this.dataForm.rescueCurrentEnv === 'BASEMENT') {
        this.dataForm.useShopDrawing = true;
      } else {
        this.dataForm.useShopDrawing = false;
      }
      this.checkPictureNum();
    },
    // 滑动到底
    async sliderCompleted() {
      this.submit();
      console.log(this.dataForm);
    },
    async submit() {
      // 校验仪表盘故障码选项必须选择一项
      if (this.isHAIC && this.isTrailer) {
        if (!this.dataForm.isBlackScreens && !this.dataForm.noBlackScreens) {
          this.showBlackScreensTips();
          return;
        }
      }
      this.isNoCar = false;
      if (!this.taskDetail.carNo && this.isShowTrailer) {
        if (!this.carNo) {
          this.isNoCar = true;
          Toast({
            message: '请填写被救车牌号码',
            position: 'bottom'
          });
          this.$refs.clickButton.reset();
          return;
        }
        if (this.carNo && !REGEX_LPN.test(this.carNo)) {
          this.isNoCar = true;
          Toast({
            message: '请填写正确的被救车牌号码',
            position: 'bottom'
          });
          this.$refs.clickButton.reset();
          return;
        }
      }
      if (!this.imageCompleted) {
        this.showImageInfo();
        return;
      }
      if (
        !(this.isTrailer || this.isBasementTrailer) &&
        this.dataForm.rescueFailed
      ) {
        if (!this.dataForm.rescueFailedReason) {
          this.showRequiredInfo();
          return;
        }
        if (this.$refs.reasonSelectBox) {
          const result = await this.$refs.reasonSelectBox.validate();
          console.log(result);
          if (!result) {
            this.$refs.clickButton.reset();
            return;
          }
        }
      }
      try {
        if (
          this.isShowService &&
          this.isArriveStatus &&
          !this.dataForm.rescueFailed &&
          this.taskDetail.providerSettleType === '4'
        ) {
          this.$refs.serviceEndRef.open();
          return;
        }
        this.showInfoConfirm();
      } finally {
        this.$refs.clickButton.reset();
      }
    },
    // 服务完成  送水，送油，送防冻液，更换轮胎，搭电，取送钥匙，轮胎打气、困境救援
    async serviceEndConfirm(val) {
      if (val) {
        try {
          await appealDistance({
            taskNo: this.taskNo,
            appealDistance: val
          });
        } catch (error) {
          console.log(error);
        }
      }
      this.getTaskDetail();
      this.$refs.serviceEndRef.cancel();
      this.showInfoConfirm();
      this.$refs.clickButton.reset();
    },
    showBlackScreensTips() {
      const confirmText = '请先选择上方仪表盘情况';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '去选择',
        confirmCallback: () => {
          this.$nextTick(() => {
            // 滚动到仪表盘选项
            this.$refs.blackScreenRef?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            this.$refs.clickButton.reset();
          });
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showImageInfo() {
      const confirmText = this.imageInfo.requiredTips || '图片缺失';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '去拍照',
        confirmCallback: () => {
          this.$nextTick(() => {
            this.toPhoto();
          });
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showRequiredInfo() {
      const confirmText = '请选择对应的救援失败原因';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '确定',
        confirmCallback: () => {
          this.$refs.clickButton.reset();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    async showInfoConfirm() {
      let confirmText2 = '';
      let isAddProductDialog = false;
      this.isAddProduct = false;
      // 平安指定合作拖车终点的时候弹窗提示
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      const data = await getTaskDetail({
        orderNo: this.orderNo,
        taskNo: this.taskNo
      });
      this.$toast.clear();

      const env =
        this.currentEnvList.find(
          (item) => item.key === this.dataForm.rescueCurrentEnv
        ) || {};
      let confirmObj = [];
      const confirmObj2 = [];
      let title = '提示';
      if (this.isQueryAccident) {
        this.needFinalConfirm = true;
      } else {
        this.needFinalConfirm = false;
      }
      if (this.taskDetail.categoryCode === 'FL90000004') {
        confirmObj = [];
        const queryObj = this.queryValueList.filter((item) => {
          return item.checked;
        });
        this.queryAccidentList &&
          this.queryAccidentList.forEach((item) => {
            item.list &&
              item.list.forEach((items) => {
                if (items.checked) {
                  confirmObj.push({
                    key: item.desc,
                    value:
                      items.parameter === 'D01'
                        ? `${items.productSkuName}${queryObj[0].value}个`
                        : items.productSkuName
                  });
                }
              });
          });
        if (confirmObj.length <= 0) {
          Toast({
            message: '至少选择一项事故救援需要的服务项目',
            position: 'bottom'
          });
          this.$refs.clickButton.reset();
          return;
        }
      } else {
        // 环境有一个不相等
        if (this.taskDetail.rescueCurrentEnv && (env.key !== this.taskDetail.rescueCurrentEnv)) {
          isAddProductDialog = true;
        }

        if (this.isTrailer || this.isBasementTrailer) {
          // 每次提交，获取最新的增值产品的值
          if (data) {
            (data.extraProduct || []).forEach((item) => {
              if (item.desc === '00001') {
                this.originalTrainingWheels = item.value || '';
              } else if (item.desc === '00002') {
                this.originalUseShopDrawing = item.value === 1;
              }
            });
          }
          const originalDrawing = this.originalUseShopDrawing ? '1' : '0';
          this.originalTrainingWheels = this.originalTrainingWheels || '';
          this.dataForm.trainingWheels = this.dataForm.trainingWheels || '';
          let drawing = '0';
          if (this.showShopDrawing) {
            drawing = this.dataForm.useShopDrawing ? '1' : '0';
          }

          // 增值产品有一个不相等，都弹提示
          if (isAddProductDialog || originalDrawing !== drawing || this.originalTrainingWheels !== this.dataForm.trainingWheels) {
            isAddProductDialog = true;
            title = '是否确认更新数据？';
            // 环境未改变，有增值产品改变，也要加上环境的显示
            confirmObj = [
              {
                key: '类型',
                value: this.taskDetail.productCategoryName
              },
              {
                key: '救援环境',
                value: env.value
              }
            ];
            confirmObj2.push(
              {
                key: '您提交的',
                value: '',
                space: true
              },
              {
                key: '辅助轮数量：',
                value: this.dataForm.trainingWheels || '无'
              },
              {
                key: '地库牵引：',
                value: drawing
              }
            );
            if (drawing !== '0') {
              this.isAddProduct = true;
            }
            if (this.dataForm.trainingWheels && this.dataForm.trainingWheels !== '') {
              this.isAddProduct = true;
            }
          }
          this.needFinalConfirm = true;
        } else {
          confirmObj.push({
            key: '救援结果',
            value: this.dataForm.rescueFailed ? '救援失败' : '救援成功'
          });
          if (this.isDifficultyRelief) {
            if (this.dataForm.useTraceCar) {
              confirmObj.push(
                {
                  key: '是否拖车',
                  value: this.formatterInfo(this.dataForm.useTraceCarTon)
                },
                {
                  key: '辅助轮数量',
                  value: this.dataForm.trainingWheels || '无'
                },
                {
                  key: '地库牵引',
                  value: this.dataForm.useShopDrawing ? '有' : '无'
                }
              );
              this.needFinalConfirm = true;
            } else {
              confirmObj.push({
                key: '是否拖车',
                value: '无'
              });
            }
            if (this.showVasTrailer) {
              confirmObj.push({
                key: '困境拖车',
                value: this.dataForm.needVasTrailer ? '有' : '无'
              });
            }
            if (this.showVasCrane) {
              confirmObj.push({
                key: '困境吊车',
                value: this.dataForm.needVasCrane ? '有' : '无'
              });
            }
            confirmObj.push(
              {
                key: '辅助轮数量',
                value: this.dataForm.trainingWheels || '无'
              },
              {
                key: '地库牵引',
                value: this.dataForm.useShopDrawing ? '有' : '无'
              },
              {
                key: '吊车',
                value: this.formatterInfo(this.dataForm.rescueCrane)
              },
              {
                key: '叉车',
                value: this.formatterInfo(this.dataForm.rescueForklift)
              },
              {
                key: '挖掘机',
                value: this.formatterInfo(this.dataForm.rescueGrabMachine)
              }
            );
          }
        }
      }
      if (data) {
        const { cooperativeOutlet } = data;
        if (cooperativeOutlet === 1) {
          confirmText2 = [
            {
              text: '此订单为平安指定合作拖车终点，需严格按照此终点进行服务。如客户有临时变更终点需求，可指引'
            },
            {
              text: '客户通过好车主APP/短信链接在线修改拖车终点',
              color: 'red'
            },
            {
              text: '，并将车辆拖至更改后的终点。'
            }
          ];
        }
      }
      if (isAddProductDialog) {
        this.$refs.addValueProductDialogRef.open({
          title,
          confirmObj,
          confirmObj2,
          confirmCallback: () => {
            if (this.needFinalConfirm) {
              this.$nextTick(() => {
                this.showFinalConfirm();
              });
            } else {
              this.saveInfo();
            }
          },
          cancelCallback: () => {
            this.$refs.clickButton.reset();
          }
        });
      } else {
        // 不需要弹框时，忘下一步执行
        if (this.isTrailer || this.isBasementTrailer) {
          if (this.needFinalConfirm) {
            this.$nextTick(() => {
              this.showFinalConfirm();
            });
          } else {
            this.saveInfo();
          }
          return;
        }
        this.$refs.confirmDialog.open({
          title,
          confirmObj,
          confirmText2,
          cancelButtonText: '返回修改',
          confirmButtonText: this.needFinalConfirm
            ? '信息无误下一步'
            : '确认提交',
          confirmCallback: () => {
            if (this.needFinalConfirm) {
              this.$nextTick(() => {
                this.showFinalConfirm();
              });
            } else {
              this.saveInfo();
            }
            this.$refs.clickButton.reset();
          },
          cancelCallback: () => {
            this.$refs.clickButton.reset();
          }
        });
      }
    },
    formatterInfo(val) {
      return isNaN(val) ? val : val + '吨';
    },
    showFinalConfirm() {
      const confirmText =
        '确认将开始计算拖车时间与拖车里程，请在开始行驶之前执行此操作。';
      this.$refs.confirmDialog.open({
        confirmText,
        confirmCallback: () => {
          this.saveInfo();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showTrailer() {
      const extraInfoList = [];
      const queryObj = this.queryValueList.filter((item) => {
        return item.checked;
      });
      this.queryAccidentList &&
        this.queryAccidentList.forEach((item) => {
          item.list &&
            item.list.forEach((items) => {
              if (items.checked && items.parameter !== 'D01') {
                extraInfoList.push({
                  code: items.productSkuCode,
                  desc: item.desc,
                  name: items.productSkuName,
                  value: 1
                });
              }
              if (queryObj.length > 0 && items.parameter === 'D01') {
                extraInfoList.push({
                  code: items.productSkuCode,
                  desc: item.desc,
                  name: items.productSkuName,
                  value: queryObj[0].value || ''
                });
              }
            });
        });
      console.log(extraInfoList, 'extraInfoList');
      return extraInfoList;
      // const obj = {
      //   extraInfo: extraInfoList,
      //   taskNo: this.taskDetail.taskNo
      // };
      // await saveExtra(obj);
    },
    getPhotoParams(photo = false) {
      // PICTURE_DEFAULT("000", "默认"),
      // PICTURE_SECNE("009", "现场照片"),
      // PICTURE_CANCEL_FEE("010", "取消有费"),
      // PICTURE_EMPTY("011", "放空"),
      // PICTURE_FINISH("006", "服务完成"),
      // PICTURE_TRANING_WHEEL("012", "辅助轮"),
      // PICTURE_TRACTION("013", "地库牵引"),
      // PICTURE_OTHER("007", "其他");
      const params = {};
      if (this.isTrailer || this.isBasementTrailer) {
        params.useTraceCar = 1;
      } else {
        params.useTraceCar = 0;
      }
      params.pictureTypes = ['009'];
      console.log('----this.dataForm.trainingWheels', this.dataForm.trainingWheels);
      if (this.dataForm.trainingWheels) {
        // 获取skuValueCode
        const find = this.extraProductList.find(
          (item) => item.desc === '00001'
        );
        params.pictureTypes.push(find ? find.skuValueCode : '012');
      }
      console.log('----this.dataForm.useShopDrawing', this.dataForm.useShopDrawing);
      if (this.dataForm.useShopDrawing) {
        // 获取skuValueCode
        const find = this.extraProductList.find(
          (item) => item.desc === '00002'
        );
        params.pictureTypes.push(find ? find.skuValueCode : '013');
      }
      if (this.taskDetail.categoryCode === 'FL90000004') {
        this.queryAccidentList &&
          this.queryAccidentList.forEach((item) => {
            item.list &&
              item.list.forEach((items) => {
                if (items.checked) {
                  params.pictureTypes.push(items.skuValueCode);
                }
              });
          });
      }
      return params;
    },
    async toPhoto() {
      // 平安订单
      if (
        this.taskDetail.isPaicOrder === 1 &&
        !this.accidentRescueTypeList.includes(this.taskDetail.categoryCode)
      ) {
        let confirmText = '平安订单，请穿平安好车主橙色马甲！';
        // 搭电产品
        if (this.taskDetail.categoryCode === 'FL10000006') {
          confirmText = '平安订单，请穿平安好车主橙色马甲，拍摄搭电前检测仪照片！';
        }
        this.$refs.confirmDialog.open({
          confirmText,
          showCancelButton: false,
          confirmButtonText: '确认',
          confirmCallback: () => {
            // 去拍照页面
            this.toPhotoPage();
          }
        });
      } else {
        // 去拍照页面
        this.toPhotoPage();
      }
      this.$refs.clickButton.reset();
    },
    // 页面跳转
    toPage(name) {
      const params = this.getPhotoParams();
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      if (name === 'GeneralOrderEvacuation') {
        router.query = {
          appServiceType: this.taskDetail.appServiceType,
          useTraceCar: params.useTraceCar,
          productCategoryName: this.taskDetail.productCategoryName,
          workerName: this.taskDetail.workerName
        };
        this.$router.push(router);
      } else {
        this.$router.replace(router);
      }
    },
    // 跳转照片页面
    async toPhotoPage() {
      await this.$nextTick();
      const params = this.getPhotoParams();
      params.orderNo = this.orderNo;
      params.taskNo = this.taskNo;
      const router = {
        name: 'GeneralOrderCertificate',
        query: {
          photoParams: JSON.stringify(params)
        }
      };
      console.log('router: ', router);
      // this.$router.push(router);
    },
    openEntryBox() {
      const params = this.getPhotoParams();
      const title = `${
        this.taskDetail.appOrderPayType || ''
      }客户，请记录订单费用`;
      this.$refs.orderCostEntryBox.open({
        title,
        showAll: params.useTraceCar === 1,
        extraParam: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        confirmCallback: (res) => {
          console.log('dataForm:', res);
        },
        cancelCallback: () => {}
      });
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          const {
            rescueCurrentEnv,
            useTraceCar,
            useTraceCarTon,
            rescueCrane,
            rescueForklift,
            rescueGrabMachine,
            rescueResult,
            rescueResultRemark,
            extraProduct
          } = this.taskDetail;
          // 空值处理 & 数据回显
          this.dataForm = {
            ...this.dataForm,
            useTraceCar: useTraceCar || false,
            useTraceCarTon: useTraceCarTon || '5',
            rescueCrane: rescueCrane || '无',
            rescueForklift: rescueForklift || '无',
            rescueGrabMachine: rescueGrabMachine || '无',
            rescueFailed: rescueResult === 0,
            rescueOpinion: rescueResultRemark,
            rescueFailedReason: rescueResultRemark
          };
          if (rescueCurrentEnv) {
            this.dataForm.rescueCurrentEnv = rescueCurrentEnv;
          } else {
            // 地库拖车默认地库，拖车如果没传默认一般地面
            this.dataForm.rescueCurrentEnv = this.isBasementTrailer
              ? 'BASEMENT'
              : 'COMMON_GROUND';
          }
          (extraProduct || []).forEach((item) => {
            if (item.desc === '00001') {
              this.dataForm.trainingWheels = item.value || '';
              this.originalTrainingWheels = item.value || '';
            } else if (item.desc === '00002') {
              this.dataForm.useShopDrawing = item.value === 1;
              this.originalUseShopDrawing = item.value === 1;
            }
          });
          // 地库环境+困境有拖车才默认使用地库牵引
          if (this.dataForm.rescueCurrentEnv === 'BASEMENT') {
            this.dataForm.useShopDrawing = true;
            this.originalUseShopDrawing = true;
          }
          // 设置选中之前的值
          this.preRescueCurrentEnv = this.dataForm.rescueCurrentEnv;
          this.preTrainingWheels = this.dataForm.trainingWheels;
          if (this.taskDetail.categoryCode === 'FL90000004') {
            this.isShowTrailer = true;
            this.queryAccidentVasDict();
          } else {
            this.isShowTrailer = false;
          }
          // 华安拖车 仪表盘无故障码或者黑屏 回写
          this.dataForm.isBlackScreens = this.taskDetail.blackScreen === 1;
          this.dataForm.noBlackScreens = this.taskDetail.blackScreen === 2;
          this.getRightRemark();
          this.getExtraProductList();
          // 获取可复制的服务凭证信息
          this.getMediaTemplate();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取影像模板
    async getMediaTemplate() {
      const res = await getMediaTemplate({
        orderNo: this.orderNo,
        templateType: 'mainTemplate',
        source: 4
      });
      if (res) {
        const data = res || [];
        const arr = [];
        for (const item of data) {
          if (item.secondary) {
            const arr2 = [];
            for (const item2 of item.secondary) {
              if (item2.requiredNum > 0) {
                arr2.push(item2.typeName);
              }
            }
            if (arr2.length > 0) {
              arr.push(`${item.primaryName}(${arr2.join('、')})`);
            }
          }
        }
        this.copyText = this.taskDetail.orderNo + '\n' + arr.join('、');
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async getExtraProductList() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getExtraProductList({
          taskNo: this.taskNo
        });
        this.extraProductList = data || [];
        this.checkPictureNum();
      } catch (error) {
        console.log(error);
      }
    },
    async checkPictureNum(noLoading) {
      await this.$nextTick();
      if (!noLoading) {
        this.$toast.loading({
          message: '正在更新图片数据...',
          forbidClick: true
        });
      }
      const params = this.getPhotoParams();
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await checkPictureNum({
          orderNo: this.orderNo,
          ...params
        });
        const { requiredNum, total, requiredTips } = data || {};
        this.imageCompleted = !isNaN(total) && total === requiredNum;
        this.imageInfo = {
          photoNumTaked: requiredNum,
          photoNumAll: total,
          requiredTips
        };
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async queryDictByCodes() {
      try {
        const res = await queryDictByCodes({
          codes: [
            'rescueCurrentEnv', // 救援时当前环境
            'useTraceCarTon', // 拖车吨数
            'rescueCrane', // 困境救援吊车
            'rescueForklift', // 困境救援叉车
            'rescueFialReason' // 救援失败原因
          ]
        });
        if (res) {
          this.currentEnvList = res.find(
            (item) => item.code === 'rescueCurrentEnv'
          ).kvs;
          this.trailerTonnageList = res.find(
            (item) => item.code === 'useTraceCarTon'
          ).kvs;
          this.craneDataList = res.find(
            (item) => item.code === 'rescueCrane'
          ).kvs;
          this.forkliftDataList = res.find(
            (item) => item.code === 'rescueForklift'
          ).kvs;
          this.reasonDataList = res.find(
            (item) => item.code === 'rescueFialReason'
          ).kvs;
          this.getTaskDetail();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveInfo(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '保存中...',
          forbidClick: true
        });
      }
      // if (this.taskDetail.categoryCode === 'FL90000002') {
      //   this.showTrailer();
      // }
      try {
        const {
          rescueCurrentEnv,
          useTraceCar,
          useTraceCarTon,
          rescueCrane,
          rescueForklift,
          rescueGrabMachine,
          rescueFailed,
          rescueOpinion,
          rescueFailedReason,
          trainingWheels,
          useShopDrawing,
          needVasTrailer,
          needVasCrane,
          isBlackScreens,
          noBlackScreens
        } = this.dataForm;
        let vasProductInfo = [];
        // 设置增值产品
        if (this.showTrainingWheels && trainingWheels) {
          const vasInfo = this.extraProductList.find(
            (item) => item.desc === '00001'
          );
          vasInfo.value = trainingWheels;
          vasProductInfo.push(vasInfo);
        }
        if (this.showShopDrawing && useShopDrawing) {
          const vasInfo = this.extraProductList.find(
            (item) => item.desc === '00002'
          );
          vasInfo.value = 1;
          vasProductInfo.push(vasInfo);
        }
        if (this.showVasTrailer && needVasTrailer) {
          const vasInfo = this.extraProductList.find(
            (item) => item.desc === '00009'
          );
          vasInfo.value = 1;
          vasProductInfo.push(vasInfo);
        }
        if (this.showVasCrane && needVasCrane) {
          const vasInfo = this.extraProductList.find(
            (item) => item.desc === '00005'
          );
          vasInfo.value = 1;
          vasProductInfo.push(vasInfo);
        }
        if (this.isShowTrailer) {
          const extraInfoList = this.showTrailer();
          vasProductInfo = extraInfoList;
        }
        await saveInfo({
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          carNo: this.carNo || this.taskDetail.carNo,
          rescueCurrentEnv,
          useTraceCar: useTraceCar ? 1 : 0,
          useTraceCarTon,
          rescueCrane,
          rescueForklift,
          rescueGrabMachine,
          rescueResult: rescueFailed ? 0 : 1,
          rescueResultRemark: rescueFailed ? rescueFailedReason : rescueOpinion,
          vasProductInfo,
          blackScreen: isBlackScreens ? 1 : noBlackScreens ? 2 : 0
        });
        if (!noLoading) {
          this.$toast.clear();
        }
        this.savePictureTemplate();
      } catch (error) {
        console.log(error);
      }
    },
    async savePictureTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const params = this.getPhotoTemplateParams();
        console.log('params', params);
        await savePictureTemplate({
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        if (!noLoading) {
          this.$toast.clear();
        }
        // 判断类型 流转对应状态
        const { rescueFailed } = this.dataForm;
        if (!(this.isTrailer || this.isBasementTrailer) && rescueFailed) {
          this.rescueResult();
        } else if (
          this.isTrailer ||
          this.isBasementTrailer ||
          this.isQueryAccident
        ) {
          this.beginWork();
        } else {
          this.executeSuccess();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 这个是已最后的为准，getPhotoParams是时候更新，需要更新增值产品的sku给检测照片数量和模版接口
    getPhotoTemplateParams() {
      // PICTURE_DEFAULT("000", "默认"),
      // PICTURE_SECNE("009", "现场照片"),
      // PICTURE_CANCEL_FEE("010", "取消有费"),
      // PICTURE_EMPTY("011", "放空"),
      // PICTURE_FINISH("006", "服务完成"),
      // PICTURE_TRANING_WHEEL("012", "辅助轮"),
      // PICTURE_TRACTION("013", "地库牵引"),
      // PICTURE_OTHER("007", "其他");
      const params = {};
      if (this.isTrailer || this.isBasementTrailer) {
        params.useTraceCar = 1;
      } else {
        params.useTraceCar = 0;
      }
      params.pictureTypes = ['009'];
      // 有增值产品弹框的，才添加增值产品模版
      if (this.isAddProduct) {
        if (this.dataForm.trainingWheels) {
          // 获取skuValueCode
          const find = this.extraProductList.find(
            (item) => item.desc === '00001'
          );
          params.pictureTypes.push(find ? find.skuValueCode : '012');
        }
        if (this.dataForm.useShopDrawing) {
          // 获取skuValueCode
          const find = this.extraProductList.find(
            (item) => item.desc === '00002'
          );
          params.pictureTypes.push(find ? find.skuValueCode : '013');
        }
      }
      if (this.taskDetail.categoryCode === 'FL90000004') {
        this.queryAccidentList &&
          this.queryAccidentList.forEach((item) => {
            item.list &&
              item.list.forEach((items) => {
                if (items.checked) {
                  params.pictureTypes.push(items.skuValueCode);
                }
              });
          });
      }
      return params;
    },
    async beginWork(noLoading, skipCcqc001010WatermarkDistanceCheck = null) {
      if (!this.currentPosition) {
        this.$toast('当前位置获取失败，请确认是否打开位置权限！');
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const res = await beginWork({
          // 是否跳过拖车车头对角45度整车照水印里程校验
          skipCcqc001010WatermarkDistanceCheck,
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...this.currentPosition
        });
        if (res && res.code) {
          if (res.code === '7012') {
            const confirmText = res.message || '';
            this.$refs.confirmDialog.open({
              confirmText,
              confirmButtonText: '继续',
              confirmCallback: () => {
                this.beginWork(false, 1);
              }
            });
            return;
          }
        }
        // 正在拖车
        this.toPage('GeneralOrderTrailing');
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async executeSuccess(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await executeSuccess({
          taskNo: this.taskNo,
          rescueResult: 1,
          rescueResultRemark: this.dataForm.rescueOpinion
        });
        this.toPage('GeneralOrderExecuted');
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async rescueResult(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await rescueResult({
          taskNo: this.taskNo,
          rescueResult: 0,
          rescueResultRemark: this.dataForm.rescueFailedReason
        });
        this.$refs.confirmDialog.close();
        this.toPage('GeneralOrderExecuted');
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    setCurrentScrollTop() {
      this.$refs.showMoreRef && this.$refs.showMoreRef.setCurrentScrollTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box {
  .top-box {
    overflow-y: auto;

    height: calc(100vh - 72px - 46px);

    background: #f2f3f5;
  }
  .bottom-box {
    height: 72px;
  }
}
.flex-box {
  display: flex;
}
.content-box {
  padding-bottom: 32px;

  .workOrders {
    padding: 0 12px;
  }

  .car-info-box {
    padding: 13px 16px 15px;
    // border-bottom: 1px solid rgba(200,200,200,1);

    background: #ffffff;

    .car-info-item {
      display: flex;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
      & + .car-info-item {
        padding-top: 8px;
      }
      .carNo {
        padding: 0;
      }
      .car_red {
        color: #f32222;
      }
      .vip-icon {
        width: 19px;
        height: 18px;
        margin-top: 2px;
        margin-left: 4px;
      }

      .zv-vip-icon {
        margin-left: 4px;
        margin-top: 2px;
        padding: 0 4px;
        text-align: center;
        letter-spacing: 0;
        color: #ffffff;
        border-radius: 4px;
        background: #f32222;
        font-family: PingFangSC-Regular;
        font-size: 10px;
        font-weight: 400;
        line-height: 18px;
        height: 18px;
        white-space: nowrap;
      }
      .copy {
        margin-left: 4px;
        padding: 0 5px;

        white-space: nowrap;

        color: #3399ff;
        border: 1px solid #3399ff;
        border-radius: 5px;
        background: #eaf4ff;

        font-size: 10px;
      }
      span {
        &:first-child {
          flex: 0 0 74px;
        }
        & + span {
          color: #383838;
        }
        &.car-no {
          font-family: PingFangSC-Medium;
          font-weight: 500;

          &.color-red {
            color: #f32222;
          }

          &.order-no {
            flex: 0 0 150px;

            word-break: break-all;
          }

          &.order-svip {
            flex: 0 0 100px;
            word-break: break-all;
          }
        }
      }
      .edit {
        margin: 2px 10px;

        color: #3399ff;
      }
    }
  }

  .card-box {
    margin: 12px 12px 0;

    border-radius: 8px;
    background: #ffffff;

    &.card-padding {
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title {
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info {
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon {
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #f32222;
        }
      }
      .card-tips__gary {
        color: #787878;

        font-size: 12px;
      }
      .card-tag {
        margin-left: 8px;
        padding: 1px 8px 2px;

        letter-spacing: -0.31px;

        border-radius: 2px;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        &.card-tag__red {
          color: #c78062;
          background: #fff0ea;
        }
      }
      .card-text-btn {
        text-align: right;
        letter-spacing: -0.38px;

        color: #3399ff;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
      }
    }
    .card-info {
      margin-top: 10px;

      color: #383838;

      font-size: 15px;
    }
    .card-tips__red {
      color: #f32222;
    }

    ::v-deep .van-checkbox {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      .van-checkbox__icon {
        font-size: 16px;
        &.van-checkbox__icon--checked .van-icon {
          border-color: #3399ff;
          background-color: #3399ff;
        }
        .van-icon {
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
        }
      }
    }

    .placeholder-box {
      margin-bottom: 24px;
    }

    .van-button {
      text-align: center;
      letter-spacing: -0.38px;

      color: #ffffff;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info {
        border-color: #3399ff;
        background-color: #3399ff;
      }

      &.van-button--large {
        height: 39px;
      }
    }
  }

  .select-box {
    .select-item {
      padding: 5px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #646464;
      border-radius: 4px;
      background: #e1e7ed;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      &.active {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
  .collapse {
    border-bottom: 1px solid #e6e6e6;
    .isActive {
      color: #ff8a59;

      font-size: 12px;
    }
    ::v-deep .accidentValue {
      color: #3399ff;
    }
    ::v-deep .van-cell__right-icon {
      color: #3399ff;
    }
    ::v-deep .van-cell {
      padding: 10px 0;
    }
    ::v-deep .van-collapse-item__content {
      padding: 5px 0;
    }
  }
  .collapse:last-child {
    border-bottom: 0;
  }

  .textarea-box,
  ::v-deep .textarea-box {
    padding: 12px;

    letter-spacing: -0.38px;

    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  .select-item {
    min-width: 30px;
    margin: 0 10px 10px 0;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #e1e7ed;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active {
      color: #ffffff;
      background: #3399ff;
    }
  }
}
.card-title-sub {
  // font-weight: 500;
  padding: 10px 0 15px;

  color: #787878;
  border-bottom: 1px solid #e6e6e6;

  font-family: PingFangSC-Medium;
  font-size: 15px;
}

.card-flex {
  display: flex;
  align-items: center;
}
.takeImg {
  width: 35px;
  margin-right: 10px;
}
.stateInfo {
  margin-right: 10px;

  color: #383838;

  font-size: 15px;
  font-weight: 400;
}
.isStateInfo {
  color: #f32222;
}
</style>
